import firebase from 'gatsby-plugin-firebase';

const deleteJournalEntry = async (id: string): Promise<void> => {
  await firebase.database().ref(`/journalentries/${id}`).remove();
};

export default deleteJournalEntry;
